import { https } from "../http";
import { showError, showSuccess } from "../utils/index";

export const saveDigestSettings = async ({ digestEnabled, digestFrequency, digestSections }) => {
  try {
    const response = await https().put("/digest/settings", {
      digestEnabled,
      digestFrequency,
      digestSections,
    });
    showSuccess("Notification settings saved");
    return response.data;
  } catch (err) {
    showError(err?.response?.data?.message || "Failed to save settings");
    return null;
  }
};
